// extracted by mini-css-extract-plugin
export var details = "_h4-0";
export var inspectorPopover = "_h4-1";